// eslint-disable-next-line no-unused-vars
import { http, prepareHttpQuery } from 'http';

export default {
  getTransportAct: filters => http.post(`/flex/transport/dataFlexCheck${prepareHttpQuery(filters)}`)
};
